export const User = {
    path: '/users',
    name: 'users',
    component: () => import('@/views/Setting/User/UserPage.vue'),
    children: [
        {
            path: '/users/add',
            name: 'users.add',
            component: () => import('@/views/Setting/User/Form/UserForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/users/edit/:id',
            name: 'users.edit',
            component: () => import('@/views/Setting/User/Form/UserForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/users/delete/:id',
            name: 'users.delete',
            component: () => import('@/views/Setting/User/Form/UserForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/users/view/:id',
            name: 'users.view',
            component: () => import('@/views/Setting/User/Form/UserForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/users/change_password/:id',
            name: 'users.change_password',
            component: () => import('@/views/Setting/User/Form/ChangePassword.vue'),
        }
    ]
}

export const UserConfiguration = {
    path: '/users_configuration',
    name: 'users_configuration',
    component: () => import('@/views/Setting/User/Form/UserConfiguration.vue'),
}